<template>
  <el-drawer :visible.sync="drawer" size="500px" :with-header="false">
    <div class="see-shipment-drawer">
      <div>
        <i class="el-icon-close" style="font-size:22px" @click="onClose"></i>
      </div>
      <div class="title-font-style" style="margin:20px 0 20px">
        <span>询价产品信息</span>
      </div>
      <el-table
        border
        ref="tableRef"
        :data="topList"
        tooltip-effect="dark"
        :header-cell-style="tableHeader"
        element-loading-text="拼命加载中请稍后..."
        element-loading-spinner="el-icon-loading"
      >
        <el-table-column prop="brandName" label="品牌" show-overflow-tooltip></el-table-column>
        <el-table-column prop="proType" label="型号" show-overflow-tooltip></el-table-column>
        <el-table-column prop="orderNumber" label="订货号" show-overflow-tooltip></el-table-column>
        <el-table-column prop="ocUnit" label="单位" width="50" show-overflow-tooltip></el-table-column>
        <el-table-column prop="ocExtime" label="期望货期" show-overflow-tooltip>
          <template slot-scope="scope">{{scope.row.ocExtime}}天</template>
        </el-table-column>
        <el-table-column prop="ocNeednumber" label="询价数量"></el-table-column>
      </el-table>
      <div></div>
      <div class="title-font-style" style="margin:30px 0 20px">
        <span>其他方案</span>
      </div>
      <el-radio-group v-model="radio" class="radio-box">
        <div v-for="(item,i) in list" :key="i">
          <el-radio :label="i+1">{{item.name}}</el-radio>
          <el-table
            class="table-box"
            :style="i+1===list.length?'margin-bottom:0':''"
            border
            :show-summary="item.supplierOfferList.length>1?true:false"
            :summary-method="getSummaries"
            :data="item.supplierOfferList"
            :header-cell-style="tableHeader"
          >
            <el-table-column prop="extime" label="货期" show-overflow-tooltip>
              <template slot-scope="scope">{{scope.row.extime}}天</template>
            </el-table-column>
            <el-table-column prop="stockCount" label="数量" show-overflow-tooltip></el-table-column>
            <el-table-column prop="supPrice" label="供货单价" show-overflow-tooltip>
              <template slot-scope="scope">{{scope.row.supPrice|priceFilterNum}}</template>
            </el-table-column>
            <el-table-column prop="supplierSum" label="供货总价" show-overflow-tooltip>
              <template slot-scope="scope">{{scope.row.supplierSum|priceFilterNum}}</template>
            </el-table-column>
            <el-table-column label="价格有效期" width="92" show-overflow-tooltip>
              <template slot-scope="scope">{{scope.row.expire|dateFilterD}}</template>
            </el-table-column>
          </el-table>
        </div>
      </el-radio-group>
      <el-row class="footer">
        <el-col :span="24" style="text-align:center;">
          <el-button type="primary" @click="onSubmit">提交方案</el-button>
          <el-button @click="onClose">取消</el-button>
        </el-col>
      </el-row>
    </div>
  </el-drawer>
</template>
<script>
import {
  queryOtheroptions,
  queryOtheroptionsToCommit,
  queryPersonOptions,
  queryPersonOptionsToCommit
} from '@/api/sell/sellManage'
import { SectionToChinese } from '@/util/tool'
export default {
  data () {
    return {
      radio: null,
      drawer: false,
      list: [],
      type: 0, // 1 系统 2 人工
      topList: []
    }
  },
  methods: {
    getSummaries (param) {
      // 合计
      const { columns, data } = param
      const sums = []
      columns.forEach((column, index) => {
        if (index === 0) {
          sums[index] = '总计'
        } else if (index === 2 || index === 4) {
          sums[index] = ''
        } else {
          const values = data.map((item) => Number(item[column.property]))
          sums[index] = values.reduce((prev, curr) => {
            const value = Number(curr)
            if (!isNaN(value)) {
              return prev + curr
            } else {
              return prev
            }
          }, 0)
          if (index === 3) {
            sums[index] = sums[index].toFixed(2)
          }
        }
      })
      return sums
    },
    onSubmit () {
      if (!this.radio) {
        this.$message.error('请选择方案！')
      } else {
        if (this.type === 1) {
          const body = {
            ...this.list[this.radio - 1],
            orderContent: this.topList[0]
          }
          queryOtheroptionsToCommit(body).then((res) => {
            if (res.data.code === 200) {
              this.drawer = false
              this.$emit('onSubmit')
            } else {
              this.$message.error(res.data.msg)
            }
          })
        } else if (this.type === 2) {
          const obj = {
            orderContent: this.topList[0],
            orderManualIquiryOtherSchemeVoList: this.list[this.radio - 1]
              .supplierOfferList
          }
          queryPersonOptionsToCommit(obj).then((res) => {
            if (res.data.code === 200) {
              this.drawer = false
              this.$emit('onSubmit')
            } else {
              this.$message.error(res.data.msg)
            }
          })
        }
      }
    },
    init (row) {
      this.topList = [row]
      this.radio = null
      this.type = row.ocPriceSource
      if (this.type === 1) {
        queryOtheroptions(row).then((res) => {
          if (res.data.code === 200) {
            this.list = res.data.obj || []
            this.list.forEach((ele, i) => {
              ele.name = '方案' + SectionToChinese(i + 1)
            })
          } else {
            this.$message.error(res.data.msg)
          }
        })
      } else if (this.type === 2) {
        queryPersonOptions(row).then((res) => {
          if (res.data.code === 200) {
            this.list = res.data.obj || []
            this.list.forEach((ele, i) => {
              ele.name = '方案' + SectionToChinese(i + 1)
            })
          } else {
            this.$message.error(res.data.msg)
          }
        })
      }
      this.drawer = true
    },
    // 关闭弹窗
    onClose () {
      this.drawer = false
    },
    // 设置头部背景色
    tableHeader ({ rowIndex }) {
      return this.$tableHeader(rowIndex)
    }
  }
}
</script>
<style lang="scss" scoped>
.box {
  margin: 20px auto;
  width: 90%;
  display: flex;
  flex-wrap: wrap;
  overflow: hidden;
  .inner {
    box-sizing: border-box;
    padding: 10px 12px;
    width: 50%;
    height: 36px;
    font-size: 14px;
    color: #4e555b;
    border: 1px solid #ebeef5;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }
}
.radio-box {
  width: 100%;
  height: 620px;
  overflow: auto;
}
.table-box {
  margin: 10px 0 30px;
}
.see-shipment-drawer {
  padding: 20px;
  .title {
    font-size: 16px;
    font-weight: 500;
    text-align: center;
    color: rgba(78, 85, 91, 1);
  }
  .no-contet {
    margin-top: 20px;
    width: 100%;
    height: 120px;
    text-align: center;
    line-height: 120px;
    background: rgba(243, 247, 255, 1);
  }
  .footer {
    position: absolute;
    bottom: 20px;
    left: 50%;
    transform: translate(-50%, 0);
  }
}
</style>
